module.exports = __webpack_public_path__ + "img/ИФ-1(А)-035.5b4708b4.png";